import React from 'react';
import PropTypes from 'prop-types';
import RichText from '../../Prismic/RichText';
import { prismicImage } from 'src/common/utils/prismic-image';
import cx from 'classnames';

import './PromoBannerInline.scss';

const PromoBannerInline = (props) => {
  const backgroundImage = prismicImage(props.media.fabletDown ? props.backgroundImage.mobile : props.backgroundImage);

  return (
    <section className="promo-banner-inline">
      <div
        className="promo-banner-content container-guttered"
        style={{
          backgroundColor: props.backgroundColor,
          backgroundImage: `url("${backgroundImage}")`
        }}>
        <p className={cx('promo-banner-inline-title', {
          [`color-${props.contentColor}`]: props.contentColor
        })}>
          {props.title}
        </p>
        <RichText
          fields={props.description}
          className={cx('text-milli', {
            [`color-${props.contentColor}`]: props.contentColor
          })}
        />
      </div>
    </section>
  );
};

PromoBannerInline.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.array,
  contentColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.shape({
    mobile: PropTypes.object
  }),
  media: PropTypes.shape({
    fabletDown: PropTypes.bool
  }),
};

export default PromoBannerInline;



// WEBPACK FOOTER //
// ./src/client/js/view/components/DynamicLayout/PromoBannerInline/PromoBannerInline.js